import {CalendarDateValidator} from "@/components/ui/inputs/date/validator/CalendarDateValidator";
import moment from "moment";

export class StartDateValidator extends CalendarDateValidator {
    public readonly minDate: Date;
    constructor(minDate: Date) {
        super();
        this.minDate = minDate;
    }
    public isValid(date: Date): boolean {
        return moment(date).isSameOrAfter(this.minDate, "day");
    }
}
